export enum RealTimeUpdateEntityTypes {
  AUDIT_IN_PROGRESS = 'AUDIT_IN_PROGRESS',
  INVOICE_DATA_EXTRACTED = 'INVOICE_DATA_EXTRACTED',
  FILE_PROCESSING_PROGRESS = 'FILE_PROCESSING_PROGRESS',
  OUTBOUND_REPORT_IN_PROGRESS = 'OUTBOUND_REPORT_IN_PROGRESS',

}
